export const FEATURED = {
  title: "Resident & Family Portrait Social",
  desc: "A welcoming 90-minute community experience designed to bring residents, neighbors, and families together while preserving meaningful memories through professional photography.",
  image: "https://images.unsplash.com/photo-1585813597616-63e881759e9d",
};

export const INCLUDED = [
  "A professionally hosted 90-minute experience",
  "Participation for up to 10 resident households",
  "Individual, couple, or family portraits",
  "Gentle guidance so residents feel comfortable and celebrated",
  "One professionally edited digital portrait for each participating household",
  "A small collection of candid event photographs for the community",
  "Private digital delivery within seven business days",
  "Residents participate without purchasing anything",
];

export const COMMUNITY_PROVIDES = [
  "A suitable indoor event space",
  "One staff contact",
  "Resident promotion and sign-ups",
  "Appropriate photography permission or consent",
];

export const BENEFITS = [
  { icon: "Heart", title: "Strengthen community connection", desc: "Create a shared experience that brings residents, families, and staff together." },
  { icon: "Users", title: "Increase family engagement", desc: "Give families a meaningful reason to visit, participate, and reconnect." },
  { icon: "Sparkles", title: "Celebrate residents", desc: "Help every participant feel seen, valued, and remembered." },
  { icon: "Camera", title: "Preserve meaningful memories", desc: "Provide professionally created photographs that residents and families can treasure." },
];
